// src/sections/Press.js
import React from 'react';
import './Press.css';
import { usePRTimesNews } from '../hooks/usePRTimesNews';

function Press() {
  const { news, loading, error } = usePRTimesNews(5);

  // 0件の場合は非表示
  if (!loading && !error && news.length === 0) {
    return null;
  }

  return (
    <section id="press" className="press-section">
      <h2 className="section-title">NEWS</h2>
      <div className="press-content">
        {loading && (
          <p className="press-loading">読み込み中...</p>
        )}
        {error && (
          <p className="press-error">ニュースを取得できませんでした</p>
        )}
        {!loading && !error && news.length > 0 && (
          <ul className="press-list">
            {news.map((item, index) => (
              <li key={index} className="press-item">
                <a
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="press-link"
                >
                  <div className="press-image-container">
                    {item.image ? (
                      <img
                        src={item.image}
                        alt={item.title}
                        className="press-image"
                        loading="lazy"
                        decoding="async"
                      />
                    ) : (
                      <div className="press-image-placeholder" />
                    )}
                  </div>
                  <div className="press-text">
                    <p className="press-title">{item.title}</p>
                  </div>
                </a>
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
}

export default Press;
